import { render, staticRenderFns } from "./CollectionTips.vue?vue&type=template&id=d3234b06&scoped=true&"
import script from "./CollectionTips.vue?vue&type=script&lang=js&"
export * from "./CollectionTips.vue?vue&type=script&lang=js&"
import style0 from "./CollectionTips.vue?vue&type=style&index=0&id=d3234b06&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3234b06",
  null
  
)

export default component.exports